export default __webpack_public_path__ + "static/media/gallery_test(3).e8303342.png";